import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RecaptchaModule, RecaptchaV3Module } from 'ng-recaptcha-2';
import { RecaptchaComponent } from '../recaptcha/recaptcha.component';
import { IconComponent } from '../icon/icon.component';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Dedicated module for reCAPTCHA functionality.
 * This module should be imported only where CAPTCHA is actually needed,
 * not in SharedModule or PublicModule, to optimize bundle size.
 *
 * Usage:
 * - Import this module in feature modules that need CAPTCHA (e.g., AuthModule, StoresModule)
 * - Do NOT import in SharedModule or PublicModule to avoid bloating the main bundle
 *
 * Benefits:
 * - Reduces main bundle size by ~1.5-2 MB
 * - CAPTCHA library is only loaded when needed
 * - Better code organization and separation of concerns
 */
@NgModule({
  declarations: [RecaptchaComponent],
  imports: [
    IconComponent,
    CommonModule,
    RecaptchaModule,
    RecaptchaV3Module,
    TranslateModule,
  ],
  exports: [RecaptchaComponent],
})
export class CaptchaModule {}
